module.exports = __webpack_public_path__ + "img/product_chart_1.5b0529b6.png";